var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4295 35.7757C83.2319 35.3234 82.9554 34.91 82.6128 34.5548L57.6128 9.55482C57.2576 9.21224 56.8442 8.9357 56.392 8.73815C56.267 8.67982 56.1337 8.64648 56.0003 8.60065C55.6517 8.48201 55.2887 8.41054 54.9212 8.38815C54.8337 8.37982 54.7545 8.33398 54.667 8.33398H25.5003C20.9045 8.33398 17.167 12.0715 17.167 16.6673V83.334C17.167 87.9298 20.9045 91.6673 25.5003 91.6673H75.5003C80.0962 91.6673 83.8337 87.9298 83.8337 83.334V37.5007C83.8337 37.4132 83.7878 37.334 83.7795 37.2423C83.7591 36.8745 83.6876 36.5113 83.567 36.1632C83.5253 36.0298 83.4878 35.9007 83.4295 35.7757ZM69.6087 33.334H58.8337V22.559L69.6087 33.334ZM25.5003 83.334V16.6673H50.5003V37.5007C50.5003 38.6057 50.9393 39.6655 51.7207 40.4469C52.5021 41.2283 53.5619 41.6673 54.667 41.6673H75.5003L75.5087 83.334H25.5003Z",
    fill: "#00C46B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.833 50.0007H67.1663V58.334H33.833V50.0007ZM33.833 66.6673H67.1663V75.0007H33.833V66.6673ZM33.833 33.334H42.1663V41.6673H33.833V33.334Z",
    fill: "#00C46B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1c6aae7cc21796bf6157141ed1051038.svg";
export { ForwardRef as ReactComponent };